import DarkBgCardsFrame from "@/components/darkBgCards";
import {FEATURES_CONSTANTS} from "./constants";

const FeaturesComp = () => {
  return (
    <DarkBgCardsFrame
      {...FEATURES_CONSTANTS}
      columns={{base: 1, sm: 2, md: 4}}
      spacing={{base: 2, sm: 4, md: 8}}
    />
  );
};

export default FeaturesComp;
